module.exports = __webpack_public_path__ + "static/media/rain.98a44b07.svg";